export class ResetPassword {
    constructor(
        public email: string,
        public password: string,
        public confirmpassword: string,
        public token: string
    ) { }
}
